import React from 'react';

import { Notes } from './Notes/Notes';
import { NegotiationTimelineEvents } from './NegotiationTimelineEvents/NegotiationTimelineEvents';

export const BrazilTimeline: React.FunctionComponent = () => {
  return (
    <div>
      <NegotiationTimelineEvents />
      <Notes />
    </div>
  );
};
